export const headerPath =
  process.env.PUBLIC_URL +
  "/Files/Images/AtlasCopco_Logo_blue_on_transparent.png";
